import { Component, Mixins } from "vue-property-decorator";
import RightsAware from '@/lib/mixins/rights-aware';
import { DynPanelAware } from '@/components/dyn-panel';
import XInput from '@/components/x-input';
import XTextarea from '@/components/x-textarea';
import { Getter, State } from 'vuex-class';
import CavCavite from '@/lib/models/cav-cavite';
import ListDropdown from '@/components/list-dropdown';
import { lexLabel } from '@/lib/helpers';
import { LexCusTypeOuvrage } from '@/lib/models/gen-lexs';

@Component
export default class PartEmsDescriptionOuvrage extends Mixins(DynPanelAware, RightsAware) {

  @Getter getLexique;

  @State(s => s.caviteEdit.editedCavite) data: CavCavite;

  render() {
    return (
      <div class="main-tab-inner">
        <div class="columns">
          <div class="column is-4">
            <label class="label is-small">Description de l'enveloppe</label>
            <div class="field is-6">
              <label class="label is-small has-text-weight-normal">
                  Largeur
              </label>
              <div class="control">
                <XInput vModel={this.data.cus.largeurEnveloppe} ofType="number" class="input is-small"></XInput>
              </div>
            </div>
            <div class="field is-6">
              <label class="label is-small has-text-weight-normal">
                  Longueur
              </label>
              <div class="control">
                <XInput vModel={this.data.cus.longueurEnveloppe} ofType="number" class="input is-small"></XInput>
              </div>
            </div>
            <div class="field is-6">
              <label class="label is-small has-text-weight-normal">
                Existence d'un réseau ?
              </label>
              <div class="control">
                <ListDropdown class="basic"
                  vModel={this.data.cus.existenceReseau}
                  data={this.getLexique('OuiNon')}
                  labelFn={lexLabel}
                  transform={v => v.label}
                  prompt="-"/>
              </div>
            </div>
          </div>
          <div class="column is-6 is-offset-1">
            <label class="label is-small">Ouvrage</label>
            <div class="field is-6">
              <label class="label is-small has-text-weight-normal">
                  Type d'ouvrage
              </label>
              <div class="control">
                <ListDropdown class="basic"
                  vModel={this.data.cus.typeOuvrage}
                  data={this.getLexique(LexCusTypeOuvrage)}
                  labelFn={lexLabel}
                  prompt="-"/>
              </div>
            </div>
            <div class="field">
              <label class="label is-small has-text-weight-normal">
                  Commentaire sur le type d'ouvrage
              </label>
              <div class="control">
                <XTextarea vModel={this.data.cus.typeOuvrageCommentaire} class="textarea is-small" rows={2}/>
              </div>
            </div>
          </div>
        </div>
        <hr class="is-thin"/>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label is-small">Description de la cavité</label>
              <div class="control">
                <div class="columns">
                  <div class="column is-4">
                    <div class="field is-6">
                      <label class="label is-small has-text-weight-normal">
                          Hauteur max (m)
                      </label>
                      <div class="control">
                        <XInput vModel={this.data.cus.hauteurMaxCavite} ofType="number" class="input is-small"></XInput>
                      </div>
                    </div>
                    <div class="field is-6">
                      <label class="label is-small has-text-weight-normal">
                          Longueur max (m)
                      </label>
                      <div class="control">
                        <XInput vModel={this.data.cus.longueurMaxCavite} ofType="number" class="input is-small"></XInput>
                      </div>
                    </div>
                    <div class="field is-6">
                      <label class="label is-small has-text-weight-normal">
                          Largeur max (m)
                      </label>
                      <div class="control">
                        <XInput vModel={this.data.cus.largeurMaxCavite} ofType="number" class="input is-small"></XInput>
                      </div>
                    </div>
                  </div>
                  <div class="column is-4">
                    <div class="field is-6">
                      <label class="label is-small has-text-weight-normal">
                          Volume total (m3)
                      </label>
                      <div class="control">
                        <XInput vModel={this.data.cus.volumeTotal} ofType="number" class="input is-small"></XInput>
                      </div>
                    </div>
                    <div class="field is-6">
                      <label class="label is-small has-text-weight-normal">
                          Surface maxi (m2)
                      </label>
                      <div class="control">
                        <XInput vModel={this.data.cus.surfaceMaxCavite} ofType="number" class="input is-small"></XInput>
                      </div>
                    </div>
                    <div class="field is-6">
                      <label class="label is-small has-text-weight-normal">
                          Surface de l'emprise (m2)
                      </label>
                      <div class="control">
                        <XInput vModel={this.data.cus.surfaceEmprise} ofType="number" class="input is-small"></XInput>
                      </div>
                    </div>
                  </div>
                  <div class="column is-4">
                  <div class="field is-6">
                      <label class="label is-small has-text-weight-normal">
                          Profondeur min. du toit (m)
                      </label>
                      <div class="control">
                        <XInput vModel={this.data.cus.profMinToit} ofType="number" class="input is-small"></XInput>
                      </div>
                    </div>
                    <div class="field is-6">
                      <label class="label is-small has-text-weight-normal">
                          Nombre de niveaux
                      </label>
                      <div class="control">
                        <XInput vModel={this.data.cus.nbNiveau} ofType="number" class="input is-small"></XInput>
                      </div>
                    </div>
                    <div class="field is-6">
                      <label class="label is-small has-text-weight-normal">
                          Profondeur du radier (m)
                      </label>
                      <div class="control">
                        <XInput vModel={this.data.cus.profRadier} ofType="number" class="input is-small"></XInput>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-57fb4ba1/description-ouvrage.tsx" });